import { render, staticRenderFns } from "./userMGT-car-audit-info.vue?vue&type=template&id=2d5b155a&scoped=true&"
import script from "./userMGT-car-audit-info.vue?vue&type=script&lang=js&"
export * from "./userMGT-car-audit-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5b155a",
  null
  
)

export default component.exports